<template>
  <v-select
    v-model="selectValue"
    :items="items"
    hide-details
    class="mt-0 pt-0"
  >
    <template #item="{ item, props: itemProps }">
      <v-list-item v-bind="itemProps" :title="undefined">
        <CommonChip class="mr-2">{{ item.raw.text }}:</CommonChip>
        <span>{{ item.raw.value }}</span>
      </v-list-item>
    </template>
    <template #selection="{ item }">
      <CommonChip class="mr-2">{{ item.raw.text }}:</CommonChip>
      <span>{{ item.raw.value }}</span>
    </template>
  </v-select>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';

import { ITextValue } from '@/types/common';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default defineComponent({
  name: 'VCardImportSelect',

  components: { CommonChip },

  props: {
    modelValue: {
      type: String,
      default: ''
    },
    items: {
      type: Array as PropType<ITextValue<string>[]>,
      default: () => []
    }
  },

  emits: ['update:modelValue'],

  computed: {
    selectValue: {
      get (): string {
        return this.modelValue;
      },
      set (value: string) {
        this.$emit('update:modelValue', value);
      }
    },
  }
})
</script>
